<!-- Code block full screen: same dialog as the image preview -->
<ng-container *ngIf="showPopup">
    <cloudlabs-dialoge-prompt appTrapFocus appAutoFocusModal appRefocusPreviousEl [popupWidth]="'auto'"
        [dialogClass]="'code-block-popup'" [baseZIndex]="9999902" [isDialog]="showPopup"
        (popupResponse)="close()">
        <div header class="subheading">
            {{ 'PREVIEW_BUTTON' | translate }}
        </div>
        <div content>
            <div #codePopupHost></div>
        </div>
        <div footer class="col-md-12">
            <teams-button [ngClasses]="appType === 'lab' ? 'ts-btn-fluent-primary' : 'ts-btn-fluent-white pt-2 pb-2'"
                [classList]="'mt-2 btn ts-btn-fluent ts-btn-grey text-nowrap'" [title]="'CLOSE' | translate"
                (click)="close()">
            </teams-button>
        </div>
    </cloudlabs-dialoge-prompt>
</ng-container>
